<template>
  <div>
    <div class="columns is-gapless is-vcentered is-border-top is-border-bottom has-background-light is-minH50p is-marginless">
      <div class="column is-padding-left">
        <span class="is-size-6">{{ contactSearches.length }} Recherche(s)</span>
      </div>
      <div class="column is-narrow is-border-left is-self-stretched">
        <a
          @click="openContactSearchesQuickview"
          class="button is-radiusless is-small is-primary is-minH100 is-minW180P is-uppercase">
          <span>Nouvelle Recherche</span>
        </a>
      </div>
    </div>
    <table
      class="table is-fullwidth is-marginless-bottom"
      v-if="contactSearches.length">
      <thead>
        <tr class="is-size-6">
          <th><span>Date</span></th>
          <!-- <th class="is-narrow">
            <span>Nature</span>
          </th> -->
          <th class="is-fullwidth is-minW180P">
            <span>Type du bien</span>
          </th>
          <th class="is-fullwidth">
            <span>Localisation</span>
          </th>
          <th
            class="is-fullwidth">
            <span>Ville</span>
          </th>
          <th
            class="is-fullwidth">
            <span>Distance (km)</span>
          </th>
          <th class="is-fullwidth is-minW180P">
            <span>Type recherche</span>
          </th>
          <th class="is-narrow is-minW100P">
            <span>Budget</span>
          </th>
          <th class="is-narrow is-min100P">
            <span>Surface</span>
          </th>
          <th class="is-narrow">
            <span>Actions</span>
          </th>
        </tr>
      </thead>
      <contact-searches-row
        v-for="(search, i) in contactSearches"
        :key="i"
        :index="i"
        :contact="contact"
        :source="search"
        @openSearchQuickview="openContactSearchesQuickview"
        @deleteResearch="deleteContactSearch" />
    </table>
  </div>
</template>
<script>
import ContactMixin from '../ContactMixin'

export default {
  name: 'ContactSearches',
  components: {
    ContactSearchesRow: () => import('./ContactSearchesRow')
  },
  mixins: [ContactMixin],
  watch: {
    sourceContactSearches (v) {
      this.updateSources({ searches: v })
    }
  },
  methods: {
    checkForCities (contactSearches) {
      if (contactSearches && contactSearches.length) {
        for (let research of contactSearches) {
          if (research.location && research.location.length) return true
          else return false
        }
      } else {
        return false
      }
    },
    async deleteContactSearch (id) {
      try {
        await this.$api.delete(this.$resources.CONTACT_RESEARCH(this.contactPk), id)
        this.getContactSearches()
        this.$toasted.global.success('Recherche du contact supprimée')
      } catch (e) {
        console.log(e)
        this.$toasted.global.danger('Erreur lors de la suppression')
      }
    }
  }
}
</script>
